import React,{useEffect,useState} from 'react'
import {Table,Tooltip, Button,Form,Input, Select,message,Popconfirm,TreeSelect} from 'antd';
import { EditOutlined, DownloadOutlined,DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'
import { SERVER_ADDRESS } from '../../../Config/Config';
import excel from '../../../assets/excel';
import { current } from '@reduxjs/toolkit';

const { Option } = Select;

const {SHOW_PARENT} = TreeSelect

const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 14,
      },
    },
  };

const IconList = () => {
        const location = useLocation();
        const [data,setData] = useState([]);
        const [categories, setCategories] = useState([]);
        const [styles, setStyles] = useState([]);
        const [loading, setLoading] = useState(false);
        const [form] = Form.useForm();
        const [categoryValue, setCategoryvalue] = useState(location.state?.categoryValue || null)
        const [iconType, setIconType] = useState(location.state?.iconType || null )
        const [licenseType, setLicenseType] = useState(location.state?.licenseType || null)
        const navigate = useNavigate();
        const [searchTerm, setSearchTerm] = useState('');
        const [filteredData, setFilteredData] = useState([]);
        const [currentPage, setCurrentPage] = useState(location.state?.currentPage || 1);

        const handleSearch = (e) =>{
            const searchValue = e.toLowerCase();
            // setSearchTerm(searchValue);
            setFilteredData(
                data.filter((item)=>
                item.icon_name.toLowerCase().includes(searchValue)
                )
            );
        };

        useEffect(()=> {
            // if(searchTerm)
            // handleSearch(searchTerm)
            if (categoryValue?.length > 0 || searchTerm)
            handleCategoryChange(categoryValue)
            if(!searchTerm && categoryValue?.length === 0){
                console.log("ascasc")
                setFilteredData(data)
            }
        }, [searchTerm,data,categoryValue])

        useEffect(() => {
            if (location.state?.currentPage) {
                setCurrentPage(location.state.currentPage); // Restore the current page
                setCategoryvalue(location.state?.categoryValue);
                setLicenseType(location.state?.licenseType)
                setIconType(location.state?.iconType);
            }
        }, [location.state, data]);

        const columns = [
            {
                title:'Id',
                dataIndex:'icon_id',
                width:'10%',
                key:'icon_id',
                sorter:(a, b)=>a.icon_id - b.icon_id
            },
            {
                title:'Icon Name',
                dataIndex:'icon_name',
                width:'10%',
                key:'icon_name',
                sorter:(a,b)=>a.icon_name.localeCompare(b.icon_name),
                render: (text) =>{
                    const displaysearchkey = text.length > 15 ? `${text.slice(0,15)}...` :text;
                    return text.length > 15 ? (
                        <Tooltip title={text} >
                            <span>{displaysearchkey}</span>
                        </Tooltip>
                    ) : (
                        <span>{text}</span>
                    )
                }
            },
            {
                title:'Icon Image',
                dataIndex:'icon_url',
                width:'10%',
                key:'icon_url',
                render: (iconurl) => (
                    <div style={{display:'flex', justifyContent:'center'}} >
                        <img
                            src={iconurl}
                            alt = 'icon'
                            style={{
                                width:'1.9rem',
                                height:'1.9rem'
                            }}
                        >
                        </img>
                    </div>
                )
            },
            {
                title:'Category Name',
                dataIndex:'category_name',
                width:'10%',
                key:'category_name',
                sorter:(a,b)=>a.category_name.localeCompare(b.category_name),
                render: (text) =>{
                    const displaysearchkey = text.length > 15 ? `${text.slice(0,15)}...` :text;
                    return text.length > 15 ? (
                        <Tooltip title={text} >
                            <span>{displaysearchkey}</span>
                        </Tooltip>
                    ) : (
                        <span>{text}</span>
                    )
                }
            },
            {
                title:'Style Name',
                dataIndex:'style_name',
                width:'10%',
                key:'style_name',
                sorter:(a,b)=>a.style_name.localeCompare(b.style_name),
                render: (text) =>{
                    const displaysearchkey = text.length > 15 ? `${text.slice(0,15)}...` :text;
                    return text.length > 15 ? (
                        <Tooltip title={text} >
                            <span>{displaysearchkey}</span>
                        </Tooltip>
                    ) : (
                        <span>{text}</span>
                    )
                }
            },
            {
                title:'Icon type',
                dataIndex:'icon_type_name',
                width:'10%',
                key:'icon_type_name'
            },
            {
                title:'License Name',
                dataIndex:'license_name',
                width:'10%',
                key:'license_name'
            },
            {
                title:'Sort By Name',
                dataIndex:'sort_by_name',
                width:'10%',
                key:'sort_by_name'
            },
            {
                title:'Status',
                width:'10%',
                key:'status',
                render:(_,record) => (   
                    <div>
                        <Button
                         type={record.is_active === 0 ? 'primary' : 'default'}
                         danger={record.is_active !== 0}
                         onClick={() => toggleStatus(record)} >
                        {record.is_active === 0 ? 'Active':'Deactive'}
                        </Button>
                    </div>
                )
            },
            {
                title:'Options',
                width:'10%',
                key:'option',
                render: (_,record) => (
                    <div style={{display:'flex',gap:'8px'}} >
                        <Tooltip title="Edit">
                            <Button type="primary" 
                            onClick={()=>handleEdit(record)} 
                            icon={<EditOutlined />}></Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <Popconfirm
                                placement="bottom"
                                title="Delete Category"
                                description="Are you sure to delete category ?"
                                onConfirm={()=>handleDelete(record.icon_id)}
                                okText="Yes"
                                cancelText="No"
                            >
                            <Button danger icon={<DeleteOutlined />}></Button>
                            </Popconfirm>
                            
                        </Tooltip>
                    </div>
                )
            }
        ]

        const fetchIcons = async(category =null,icon_type=null,license=null) =>{
            console.log(data)
            setLoading(true);
            try {
                const response = await axios.get(`${SERVER_ADDRESS}/api/icon-list`,{
                    params:{
                        category_id: category,  // Pass category filter if selected
                        icon_type_id:icon_type,
                        license_id:license
                    }
                })
                setData(response.data)
                if (filteredData.length === 0)
                setFilteredData(
                    response.data.filter((item) =>
                        item.icon_name.toLowerCase().includes(searchTerm.toLowerCase())
                    )
                );
                setLoading(false)
            } catch (error) {
                message.error({content:'Internal server error',duration:2})
            }
            finally{
                setLoading(false)
            }
        }

        useEffect(()=>{
            fetchIcons()
        },[])

        useEffect(() => {
            const fetchCategories = async () => {
               try {
                 const response = await axios.get(`${SERVER_ADDRESS}/api/category-list`); 
                 setCategories(response.data); 
               } catch (error) {
                 message.error("Failed to fetch categories");
                 console.error(error);
               }
             };
             fetchCategories();
           }, []);
        
        //Fetch Style
        useEffect(() => {
            const fetchstyles = async () =>{
                try {
                    const response = await axios.get(`${SERVER_ADDRESS}/api/style-list`);
                    setStyles(response.data);
                } catch (error) {
                    message.error({content:'Cannot fetch style', duration:2})
                    console.log(error)
                }
            };
            fetchstyles();
        },[]) 

        const handleDelete = async (id) => {
            try {
                const response = await axios.post(`${SERVER_ADDRESS}/api/delete-icon/${id}`);
                if(response.status===200){
                    fetchIcons(); 
                    message.success({content:'Icon Deleted successfully',duration:2})
                }
                else{
                    message.success({content:'Icon cannot deleted', duration:2})
                }
            } catch (error) {
                message.error({content:'Internal server error',duration:2})
            }
        }

        const handleEdit = (record) => {
            navigate(`/frontend/dashboard/icon/edit-icon/${record.icon_id}`,{
                state: { currentPage,
                         categoryValue,
                         iconType,
                         licenseType
                 }
            });
        };
    
        const toggleStatus = async (record) =>{
            try {
                
                const newStatus = record.is_active === 1 ? 0 : 1;
                const response = await axios.post(`${SERVER_ADDRESS}/api/toggleStatus/${record.icon_id}`,
                    {is_active: newStatus}
                );

                if(response.status === 200){
                    
                    setData((prevData)=>prevData.map((item)=>item.icon_id === record.icon_id ? {...item,is_active:newStatus}:item));
                    setFilteredData((prevFilteredData) =>
                        prevFilteredData.map((item) =>
                            item.icon_id === record.icon_id ? { ...item, is_active: newStatus } : item
                        )
                    );
                    fetchIcons();
                    message.success({content:`Icon ${newStatus=== 0 ? 'Activated' : 'Deactivated'}`,duration:2});
                    
                }
                else{
                    message.error({content:'Failed to active icon',duration:2})
                }

            } catch (error) {   
                console.log(error)
                message.error({content:'Internal server error',duration:2})
            }
        }

        const categorytree = categories.map((category)=>({
            title: category.category_name,
            value: category.category_id,
            key: category.category_id
        }))

        const styletree = styles.map((style)=>({
            title:style.style_name,
            value:style.style_id,
            key:style.style_id
        }))

        const handleCategoryChange = () =>{
            console.log(categoryValue)
            let filteredData =
                 data.filter((item)=>{
                    console.log(item.category_id, categoryValue)
                    console.log(categoryValue.find((value)=>value === item.category_id));
                    return categoryValue.find((value)=>value===item.category_id);
                })

            setFilteredData(filteredData.length > 0 ? filteredData.filter((item)=>
                item.icon_name.toLowerCase().includes(searchTerm)
                ): data.filter((item)=>
                item.icon_name.toLowerCase().includes(searchTerm)
                ))
            
                    
        }

        const handleIcontype = (value) =>{
            setIconType(value);
            fetchIcons(categoryValue,value)
        }

        const handleLicenseType = (value) =>{
            setLicenseType(value);
            fetchIcons(categoryValue,iconType,value)
        }

        const categoryProps = {
            treeData:categorytree,
            value:categoryValue,
            onChange:e=>{ console.log(e); setCategoryvalue(e)},
            treeCheckable:true,
            showCheckedStrategy:SHOW_PARENT,
            placeholder:"Please Select Category",
            style:{
                width:'15%',
                marginBottom:'1rem'
            }
        }        

        const icon_type = [{
            title:'Static',
            value:'2'
        },
        {
            title:'Animation',
            value:'1'
        }
        ]
        
        const license_type = [{
            title:'Free',
            value:'1'
        },
        {
            title:'Premium',
            value:'2'
        }
        ]


  return (
    <div style={{marginTop:'4rem'}}>
        <Input 
            placeholder="Search By Icon Name"
            prefix = {<SearchOutlined />}
            value={searchTerm}
            onChange={(e)=>setSearchTerm(e.target.value)}
            style={{marginBottom:'1rem', marginRight:'1rem',width:'20%'}}
            pagination={{
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
              }}
        />  
        <TreeSelect {...categoryProps} />
        {/* <TreeSelect {...styleProps}/> */}
        <TreeSelect 
            onChange={handleIcontype}
            style={{
                marginLeft:'1rem',
                width:'15%'
            }}
            placeholder={'Select Icon Type'}
            treeData={icon_type}
        />

        <TreeSelect 
            onChange={handleLicenseType}
            style={{
                marginLeft:'1rem',
                width:'15%'
            }}
            placeholder={'Select License Type'}
            treeData={license_type}
        />

        <Button style={{marginBottom:'1rem', marginLeft:'1rem'}} >
        <DownloadOutlined /> <a href={excel} download={true} >Download Excel</a>
        </Button>
        
        <Table
            columns={columns}
            rowKey={(record)=>`${record.icon_id}`}
            dataSource={filteredData}
            loading={loading}
            pagination={{
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
            }}
        >

        </Table>
        {/* Modal */}

    </div>
  )
}

export default IconList